export { default } from './SWCookieDetect';
